export const RESET = 'EXCMDAILYPLANITEM_LIST_RESET'
export const SET_ITEMS = 'EXCMDAILYPLANITEM_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMDAILYPLANITEM_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMDAILYPLANITEM_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMDAILYPLANITEM_LIST_TOGGLE_LOADING'
